module.exports = __webpack_public_path__ + "img/buddy_mouth-06.3e25de03.svg";